import React from "react";
import { useState, useEffect } from "react";
import useQuery from "../../hook/useQuery";
import CardCentral from "../../components/Card";
import Typography from "@material-ui/core/Typography";
import useStyles from "./style";

import FormControlLabel from "@material-ui/core/FormControlLabel";

import {
  Button,
  Link,
  Checkbox,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  OutlinedInput,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import { Link as RouterLink, useHistory, useLocation } from "react-router-dom";

import UsuarioService from "../../services/usuarioService";
import { useAuth } from "../../auth/ProvideAuth";
import LoadingUser from "../LoadingUser";

const Questionnaires = (props) => {
  const location = useLocation();
  const is403 = location.state ? location.state.is403 : null;
  const redirect_rel = location.state ? location.state.redirect_rel : null;

  const auth = useAuth();

  const history = useHistory();
  const classes = useStyles();

  const query = useQuery();

  const [error, setErro] = useState({ isError: false, erroMsg: "" });
  const [radioDocument, setRadioDocument] = useState("");
  const [area, setArea] = useState("");
  const [averageSales, setAverageSales] = useState("");
  const [riskLevel, setRiskLevel] = useState("");
  const [step, setStep] = useState(1);

  const [disabled, setDisabled] = useState(true);

  const fields = [radioDocument, area, averageSales, riskLevel];

  if (auth.user != null) {
    auth.signout(() => {});
  }

  const handleDisabledButton = () => {
    fields.every((e) => e) ? setDisabled(false) : setDisabled(true);
  };

  const handleChange = (e) => {
    eval(e.target.name)(e.target.value);
  };

  useEffect(() => {
    handleDisabledButton();
  }, fields); // Apenas re-subscribe se props.friend.id mudar

  return (
    <>
      {step == 0 ? (
        <CardCentral
          sizeHeader="2.8"
          paddingHeaderTop="2.0"
          paddingHeaderBottom="2.4"
          maxHeight="45"
          maxWidth="35"
        >
          <form className={classes.form}>
            <Typography
              className={classes.text}
              component={"span"}
              gutterBottom
            >
              Para começar, vamos fazer algumas perguntas para personalizar sua
              experiência.
            </Typography>

            <div className={classes.margin}>
              <FormControl component="fieldset">
                <FormLabel className={classes.text} component="legend">
                  Qual o segmento de atuação do seu cliente?
                </FormLabel>
                <RadioGroup
                  aria-label="Gender"
                  name="setRadioDocument"
                  style={{ display: "inline" }}
                  // className={classes.group}
                  value={radioDocument}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label={
                      <Typography className={classes.label}>
                        Pessoa física
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    className={classes.label}
                    value="1"
                    control={<Radio />}
                    label={
                      <Typography className={classes.label}>
                        Pessoa jurídica
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    className={classes.label}
                    value="2"
                    control={<Radio />}
                    label={
                      <Typography className={classes.label}>
                        Pessoa física e jurídica
                      </Typography>
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>

            <div className={classes.margin}>
              <FormControl fullWidth={true} component="fieldset">
                <FormLabel className={classes.text} component="legend">
                  Qual o segmento de atuação do seu cliente?
                </FormLabel>
                <Select
                  variant="outlined"
                  value={area}
                  onChange={handleChange}
                  name="setArea"
                  displayEmpty
                  style={!area ? { color: "#ccc" } : {}}
                  className={classes.selectEmpty}
                >
                  <MenuItem value="" disabled>
                    Selecione um ou mais segmentos
                  </MenuItem>
                  <MenuItem value={10}>Ten</MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className={classes.margin}>
              <FormControl fullWidth={true} component="fieldset">
                <FormLabel className={classes.text} component="legend">
                  Qual seu ticket médio de venda?
                </FormLabel>
                <Select
                  variant="outlined"
                  value={averageSales}
                  onChange={handleChange}
                  name="setAverageSales"
                  displayEmpty
                  style={!averageSales ? { color: "#ccc" } : {}}
                  className={classes.selectEmpty}
                >
                  <MenuItem value="" disabled>
                    Selecione uma faixa de valor
                  </MenuItem>
                  <MenuItem value={10}>Ten</MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className={classes.margin}>
              <FormControl fullWidth={true} component="fieldset">
                <FormLabel className={classes.text} component="legend">
                  Como você considera o apetite de risco da sua empresa?
                </FormLabel>
                <Select
                  variant="outlined"
                  value={riskLevel}
                  onChange={handleChange}
                  name="setRiskLevel"
                  displayEmpty
                  style={!riskLevel ? { color: "#ccc" } : {}}
                  className={classes.selectEmpty}
                >
                  <MenuItem value="" disabled>
                    Selecione uma opção
                  </MenuItem>
                  <MenuItem value={10}>Ten</MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className={classes.footer}>
              <div
                className={`${classes.margin} ${classes.subForm} ${classes.footer}`}
              >
                <FormControlLabel
                  control={
                    <div style={{ marginLeft: "12px" }}>
                      <Typography component={"p"} variant="body2"></Typography>
                    </div>
                  }
                  className={classes.switch}
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={disabled}
                >
                  Continuar
                </Button>
              </div>
            </div>
          </form>
        </CardCentral>
      ) : (
        <LoadingUser />
      )}
    </>
  );
};

export default Questionnaires;
